import * as React from "react";
import { QueryRoute } from "bernie-core";
import { ESSAdapter, UitkTypeahead, TypeaheadToolbarVersion } from "uitk-react-typeahead";
import { Layer } from "bernie-view";
import { OriginFieldProps } from "../typings";
import { WizardDialogTrigger } from "./WizardDialogTrigger";
import { hotelConfig } from "src/stores/wizard/config";
import { useLocalization } from "@shared-ui/localization-context";

const OriginTypeaheadDialog = (children: JSX.Element) => {
  return (
    <QueryRoute query={{ pwaDialog: "origin" }}>
      <Layer id="typeahead">{children}</Layer>
    </QueryRoute>
  );
};

export const OriginField = (props: OriginFieldProps) => {
  if (!props.isFlightAdded) {
    return null;
  }

  const typeaheadCloseDialog = () => {
    props.closeDialog(WizardDialogTrigger.TYPEAHEADCLOSE);
  };

  const { formatText } = useLocalization();

  return (
    <div className="uitk-cell s-cell-1-1 m-cell-1-1 l-cell-1-2 xl-cell-1-2">
      <UitkTypeahead
        adapter={
          new ESSAdapter({
            client: "HotelsLandingPage",
            dest: false,
            essLogger: props.essAnalyticsLogger,
            features: "ta_hierarchy|postal_code|contextual_ta|google|consistent_display",
            guid: props.guid,
            inputId: props.formFieldModel.formFieldStid,
            lob: "FLIGHTS",
            locale: props.locale,
            maxResults: hotelConfig.locationFlight.origin.essAdapterConfig.maxResults,
            regionType: 2047,
            siteId: parseInt(props.siteId, 10),
          })
        }
        onClick={props.openDialog}
        onDismiss={typeaheadCloseDialog}
        onUpdate={props.updateOriginField}
        renderDialog={OriginTypeaheadDialog}
        hasClearButton={false}
        allowExactMatch={true}
        icon="place"
        label={formatText(props.formFieldModel.formFieldLabel)}
        name="origin"
        stid={props.formFieldModel.formFieldStid}
        toolbarVersion={TypeaheadToolbarVersion.V1}
        invalid={props.invalid}
        value={props.origin || ""}
      />
    </div>
  );
};
